import { ScheduleOfActivities, StudyEntityType } from '@faro/study-designer-model';
import { scheduleOfActivitiesClient } from '../ScheduleOfActivities/ScheduleOfActivitiesClient';
import { studyPopulationClient } from '../StudyPopulation/StudyPopulationClient';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';

const type = 'pseudo.type.studydesign.scheduleofactivities';

export type StudyDesignScheduleOfActivities = {
    studyPopulationId: string;
    defaultScheduleId: string;
    schedules: ScheduleOfActivities[];
};

const factory = createStudyEntityHookFactory<StudyDesignScheduleOfActivities>(type);
export const useStudyDesignerScheduleOfActivities = factory.list(
    async ({ studyId }, signal) => {
        const [population] = await studyPopulationClient.list({ studyId }, signal);
        const { id: studyPopulationId } = population;

        const schedules = await scheduleOfActivitiesClient.list({ studyId }, signal);

        // NOTE: Presume there will only be one study population and one schedule of activities for now
        // rendering views for multiple of each is an edge case we do not need to consider at this point
        return [
            {
                schedules,
                studyPopulationId,
                defaultScheduleId: schedules[0].id,
            },
        ];
    },
    [StudyEntityType.StudyPopulation, StudyEntityType.ScheduleOfActivities]
);
